import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="favorite-button"
export default class extends Controller {
  static targets = ["button"]
  
  connect() {
    // Handle hover effects and ensure visibility on mobile
    this.element.addEventListener("touchstart", this.handleTouchStart.bind(this))
  }

  toggleFavorite(event) {
    // Stop the event from bubbling up to parent elements
    event.stopPropagation()
  }

  handleTouchStart(event) {
    // Ensure the button is visible on touch devices where hover isn't available
    const button = this.element.querySelector(".favorite-button")
    if (button) {
      button.classList.remove("opacity-0")
      button.classList.add("opacity-100")
      
      // Hide it again after a delay (if not already favorited)
      if (!button.classList.contains("favorited")) {
        setTimeout(() => {
          button.classList.remove("opacity-100")
          button.classList.add("opacity-0")
        }, 3000)
      }
    }
  }
} 